<template>
  <div>
    <v-navigation-drawer
      :temporary="isProduction"
      dark
      :class="sideButton"
      app
      v-model="drawer"
    >
      <template v-slot:prepend>
        <changePassowrd :color="sideTop">
          <template v-slot:FullName>
            {{ UserInfo.FullName }}
          </template>

          <template v-slot:userName> User: {{ UserInfo.UserName }} </template>

          <template v-slot:userType> Type: {{ UserInfo.UserType }} </template>
        </changePassowrd>
      </template>
      <v-divider></v-divider>
      <v-list shaped dense>
        <div v-for="(item, index) in links" :key="index">
          <v-list-group
            no-action
            v-if="item.hasChild && item.child.length > 0"
            :prepend-icon="item.icon"
            append-icon="fas fa-angle-down"
            color="white"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </template>
            <v-list-item
              dense
              v-for="childs in item.child"
              :key="childs.text"
              router
              :to="childs.to"
            >
              <v-list-item-icon>
                <v-icon>{{ childs.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ childs.text }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <!-- the else part  -->
          <v-list-item
            v-else-if="!item.hasChild"
            color="white"
            router
            :to="item.to"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn color="error" @click="logOut" block>Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar dense app :color="header">
      <v-app-bar-nav-icon dark @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <span class="headline text-capitalize" v-html="HeaderTitle"> </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="IsAdmin"
        @click="SwitchAccount"
        :loading="loading"
        fab
        small
        color="error darken"
        ><v-icon color="white">fas fa-power-off</v-icon></v-btn
      >
    </v-app-bar>
  </div>
</template>
<script>
import { EventBus } from "@/main.js";
import { tokenMixin } from "@/Mixins/tokenMixins.js";
import changePassowrd from "@/components/util/ChangePassword.vue";
import { mapGetters } from "vuex";
export default {
  name: "NavHeader",
  components: { changePassowrd },
  mixins: [tokenMixin],
  props: {
    header: [String],
    sideTop: [String],
    sideButton: [String],
  },
  data() {
    return {
      drawer: true,
      loading: false,
      others: [],
    };
  },
  computed: {
    ...mapGetters(["LinksGetter", "showRtoken"]),
    isProduction() {
      // return process.env.NODE_ENV !== "development";
      return false;
    },
    HeaderTitle() {
      let scren = this.$vuetify.breakpoint.name;
      if (scren == "sm" || scren == "xs") return this.Baranch;
      return `${this.UserInfo.Company} ${this.Baranch}`;
    },
    Baranch() {
      if (this.UserInfo.UserType != "HQ-Admin")
        return `<strong class="black--text">(${this.UserInfo.UserBranch})</strong> - ${this.UserInfo.BranchType}`;
      return ``;
    },
    // links() {
    //   return this.LinksGetter;
    // },
    IsAdmin() {
      const { UserType } = this.UserInfo;
      return UserType === "Admin";
    },
    links() {
      return this.others.filter(eachlink => {
        // console.log(eachlink);
        if (eachlink.hasChild)
          return (eachlink.child = eachlink.child.filter(child => {
            return child.access == true;
          }));
        return eachlink.access == true;
      });
    },
  },
  watch: {
    showRtoken() {
      // console.log("changed");
      this.AccessLinks(this.UserAccesses.ogol);
      // console.log(this.UserAccesses.ogol);
    },
  },

  mounted() {
    EventBus.$on("PrintEvent", val => {
      this.drawer = val;
      // console.log(value);
    });

    // console.log(this.UserAccesses.ogol);
    this.AccessLinks(this.UserAccesses.ogol);

    // if (
    //   this.$vuetify.breakpoint.name === "lg" ||
    //   this.$vuetify.breakpoint.name === "xl"
    // )
    //   this.drawer = true;
    // else this.drawer = false;
  },
  methods: {
    logOut() {
      this.$store.commit("OnLogout");
    },
    SwitchAccount() {
      try {
        this.loading = true;
        this.$store
          .dispatch("GET_ONLY", "/login/switchAccount")
          .then(val => {
            this.loading = false;
            // console.log(val);
            // this.$store.commit("AdminLogout");
            this.$store.dispatch("Adminlogin", {
              token: val.data.token,
              rToken: val.data.rToken,
            });
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            console.log("error @ go back");
          });
      } catch (error) {
        console.log(error);
      }
    },

    AccessLinks(values) {
      // console.log(values);
      for (let index = 0; index < this.LinksGetter.length; index++) {
        if (this.LinksGetter[index].hasChild)
          for (
            let index2 = 0;
            index2 < this.LinksGetter[index].child.length;
            index2++
          ) {
            this.LinksGetter[index].child[index2].access = false;
          }
        else this.LinksGetter[index].access = false;
      }

      for (let index = 0; index < values.length; index++) {
        for (let index2 = 0; index2 < this.LinksGetter.length; index2++) {
          if (this.LinksGetter[index2].hasChild) {
            for (
              let Childindex = 0;
              Childindex < this.LinksGetter[index2].child.length;
              Childindex++
            ) {
              if (
                this.LinksGetter[index2].child[Childindex].text ===
                values[index]
              ) {
                this.LinksGetter[index2].child[Childindex].access = true;
              }
            }
          } else {
            if (this.LinksGetter[index2].text === values[index])
              this.LinksGetter[index2].access = true;
          }
        }
      }

      this.others = this.jsonCopy(this.LinksGetter);
    },
    jsonCopy(src) {
      return JSON.parse(JSON.stringify(src));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
